export default __webpack_public_path__ + "static/a-series-actuator-361375a60be9de1a8731f5351a26b8e8.png";